export const prebuiltSegments = [
  'At risk new signups',
  'At risk one timers',
  'At risk repeats',
  'At risk loyals',
  'Active new signups',
  'Active one timers',
  'Active repeats',
  'Active loyals',
  'Churned signups',
  'Churned one timers',
  'Churned repeats',
  'Churned loyals',
  'Most likely to buy',
];
